import { MARKETPLACES, PREMIUM_MARKETPLACES, QUICK_COMMERCE } from "@/data/content";
import BrandLogo from "@/components/BrandLogo";

const ALL_LOGOS = [...MARKETPLACES, ...PREMIUM_MARKETPLACES, ...QUICK_COMMERCE];

export function MarketplaceLogoStrip() {
  const items = [...ALL_LOGOS, ...ALL_LOGOS];
  return (
    <div data-testid="marketplace-marquee" className="overflow-hidden border-y-2 border-black bg-white py-8">
      <div className="marquee">
        {items.map((m, i) => (
          <div key={i} className="flex shrink-0 items-center gap-8 px-2">
            <div className="flex h-10 w-32 items-center justify-center md:h-12 md:w-40">
              <BrandLogo name={m.name} className="max-h-10 w-auto md:max-h-12" />
            </div>
            <span className="text-black/30">·</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function MarketplaceGrid({ items, dark = false }) {
  return (
    <div className="grid grid-cols-2 gap-0 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
      {items.map((m) => (
        <div
          key={m.name}
          data-testid={`mp-card-${m.name.toLowerCase().replace(/\s+/g, "-")}`}
          className={`group relative flex aspect-square flex-col items-center justify-center gap-3 border-2 ${
            dark ? "border-white/15 bg-black hover:bg-[#FFD700]" : "border-black bg-white hover:bg-[#FFD700]"
          } -ml-[2px] -mt-[2px] p-4 transition-colors`}
        >
          <div className="flex h-12 w-full items-center justify-center">
            <BrandLogo
              name={m.name}
              monoColor={dark ? "FFFFFF" : undefined}
              className="max-h-12 w-auto group-hover:[filter:none] transition-all"
            />
          </div>
          <span className={`mt-1 text-center text-[11px] font-medium ${dark ? "text-white/60 group-hover:text-black/80" : "text-black/60 group-hover:text-black/80"}`}>
            {m.desc}
          </span>
        </div>
      ))}
    </div>
  );
}
